<div class="container">
    <div
        data-cy="sys-status-overview-item-alarm-counter"
        class="top-container"
        *ngIf="numberOfAlarms > 0; else emptyContainer"
    >
        <mat-icon svgIcon="status-indicator" class="icon" />
        {{ numberOfAlarms }}
        {{ "system-status.overview.alarms" | translate }}
    </div>
    <div class="bottom-container">
        <div
            data-cy="sys-status-overview-item-counter"
            class="page-items"
            [ngClass]="{ disconnected_status: !isReceivingData }"
        >
            {{ isReceivingData ? pageItems : "-" }}
        </div>
        <div data-cy="sys-status-overview-item-title" class="page-title">
            {{ pageTitle | translate }}
        </div>
    </div>
</div>

<ng-template #emptyContainer class="top-container">
    <div></div>
</ng-template>
